export const RecModulePages = {
    REC_LIST: "REC_LIST",
    REC_INFORMATION: "REC_INFORMATION",
};

export const SET_ACTIVE_PAGE = "rec-module/SET_ACTIVE_PAGE";
export const SET_SEND_REC_TO_LOADING = "rec-module/SET_SEND_REC_TO_LOADING";
export const SET_TRIGGERED_PAGE = "rec-module/SET_TRIGGERED_PAGE";

export interface IActionData {
    type: string;
    payload?: IPayloadData;
}

export interface IPayloadData {
    activePage?: any;
    sendToRecLoading?: boolean;
    triggeredPage?: string;
}

export const setActivePage = (activePage): IActionData => ({
    type: SET_ACTIVE_PAGE,
    payload: { activePage },
});

export const setTriggeredPage = (triggeredPage): IActionData => ({
    type: SET_TRIGGERED_PAGE,
    payload: { triggeredPage },
});

export const setSendRecToLoading = (loading: boolean): IActionData => ({
    type: SET_SEND_REC_TO_LOADING,
    payload: { sendToRecLoading: loading },
});
